import { render, staticRenderFns } from "./YessProfilesList.vue?vue&type=template&id=c71a27f2"
import script from "./YessProfilesList.vue?vue&type=script&lang=js"
export * from "./YessProfilesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports